import { useEffect, useState } from "react";
import { useUpdateProfile, useInvalidateProfile } from "../../lib/api";

/**
 * The one-line bio field, tap-to-edit. Lives inside the profile hero card just
 * under the identity header so the name, photo, and bio read as a single unit.
 */
export function ProfileBio({ bio }: { bio: string | null }) {
  const updateProfile = useUpdateProfile();
  const invalidate = useInvalidateProfile();

  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(bio ?? "");

  useEffect(() => {
    if (!editing) setDraft(bio ?? "");
  }, [bio, editing]);

  const save = () => {
    updateProfile.mutate({ bio: draft.trim() }, { onSuccess: () => invalidate() });
    setEditing(false);
  };

  return (
    <textarea
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={save}
      rows={2}
      maxLength={300}
      placeholder="A line about you — what you're into, what you're looking for…"
      className="input-glass resize-none"
    />
  );

}
